import React, {useEffect, useState} from 'react';
import ReactChipInput from "react-chip-input";
import {arrayIncludeItem, arrayToString, stringToArray} from "@app/utils/CommonUtils";
import {cloneDeep} from "lodash";
import {LATEST_STABLE_LEVELS, LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import {requestGetJobCategoryInfo} from "@app/services/JobService";
import {callApiSaveJob} from "@pages/job/common/Services";
import {CandidateDetailLanguageMode} from "@app/constants/Tabs";
import {InputDisableView} from "@app/components/DisableView";

const JobCategoryContent = (props) => {
    const [job, setJob] = useState({input_job_category: {}});
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {jobInput, mode, onChange} = props

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    const changeSomeArrayValueToString = (inputCategory={}) => {
        const strJobCategory = cloneDeep(inputCategory)
        strJobCategory.industry = stringToArray(strJobCategory.industry)
        strJobCategory.function = stringToArray(strJobCategory.function)
        return strJobCategory
    }

    const fetchJobCategoryInfo = async (jobId) => {
        if (jobId) {
            const res = await requestGetJobCategoryInfo({job_id: jobId})
            const changeJob = {...jobInput}
            changeJob.job_id = jobId
            changeJob.input_job_category = changeSomeArrayValueToString(res.content)
            setJob(changeJob)
        }
    };

    useEffect(async () => {
        if (jobInput && mode !== CandidateDetailLanguageMode.SEARCH) {
            if (!jobInput.input_job_category) {
                jobInput.input_job_category = {}
            }
            setJob(jobInput)

            if (jobInput.id) {
                await fetchJobCategoryInfo(jobInput.id)
            }
        }
    }, [jobInput]);

    const onChangeCategoryInfo = (fieldName, value) => {
        job.input_job_category[fieldName] = value
        setJob({...job})
        if (onChange) {
            onChange(job)
        }
    };

    const onSave= () => {
        const body = cloneDeep(job)
        body.input_job_category.industry = arrayToString(body.input_job_category.industry)
        body.input_job_category.function = arrayToString(body.input_job_category.function)
        callApiSaveJob(body, (res) => {
            const newEmployer = res.content
            job.id = newEmployer.id
            setJob({...job})
        })
    }

    const onAddIndustryFunction = (fieldName, value) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(job.input_job_category[fieldName])
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            job.input_job_category[fieldName] = arr
            setJob({...job})
            if (onChange) {
                onChange(job)
            }
        } else {
            alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
        }
    }

    const onRemoveIndustryFunction = (index, fieldName) => {
        let arr = cloneDeep(job.input_job_category[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            job.input_job_category[fieldName] = arr
            setJob({...job})
            if (onChange) {
                onChange(job)
            }
        }
    }


    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Phân loại</h3>
                <div className='card-tools'>
                    {mode !== CandidateDetailLanguageMode.SEARCH &&
                    <button type='button' className='btn btn-primary'
                            onClick={() => onSave()}>Save
                    </button>
                    }
                </div>
            </div>
            <div className='card-body'>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Industry</label>
                    <div style={{width: '100%'}}>
                        <ReactChipInput
                            classes={`class1 class2 w-100`}
                            name={'industry'}
                            chips={job.input_job_category.industry ? job.input_job_category.industry : []}
                            onSubmit={value => onAddIndustryFunction('industry', value)}
                            onRemove={index => onRemoveIndustryFunction(index, 'industry')}
                        />
                        {!userLoginInfo.is_superuser && <InputDisableView/>}
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Function</label>
                    <div style={{width: '100%'}}>
                        <ReactChipInput
                            classes={`class1 class2 w-100`}
                            name={'function'}
                            disabled={!userLoginInfo.is_superuser}
                            chips={job.input_job_category.function ? job.input_job_category.function : []}
                            onSubmit={value => onAddIndustryFunction('function', value)}
                            onRemove={index => onRemoveIndustryFunction(index, 'function')}
                        />
                        {!userLoginInfo.is_superuser && <InputDisableView/>}
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Job Level</b></label>
                    <select className={`form-control`}
                            value={job.input_job_category.job_level ? job.input_job_category.job_level : ''}
                            name={'job_level'}
                            disabled={!userLoginInfo.is_superuser}
                            onChange={event => onChangeCategoryInfo("job_level", event.target.value)}>
                        {LATEST_STABLE_LEVELS.map((item, index) => {
                            return <option value={item.toLowerCase()} key={`job_level_option_item_${item}`}>{item}</option>
                        })}
                    </select>
                </div>
            </div>
        </div>
    )
}

export default JobCategoryContent;
